module.exports = __webpack_public_path__ + "img/draw-gift.14c729ab.png";